/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface INewbuildingContactForPromoSnippetOnMapResponse {
  /** ID ЖК. **/
  newbuildingId: number;
  /** Телефон. **/
  userPhone: string;
  /** Тип контакта. **/
  contactType: EContactType;
  /** Id пользователя. **/
  userId: number;
  /** Тип тарифа. **/
  tariffType: ETariffType;
  /** ID компании. **/
  companyId?: TNewbuildingContactForPromoSnippetOnMapResponse_CompanyId;
  /** Название компании. **/
  companyName?: TNewbuildingContactForPromoSnippetOnMapResponse_CompanyName;
  /** Id динамической подмены. **/
  siteBlockId?: TNewbuildingContactForPromoSnippetOnMapResponse_SiteBlockId;
}

export enum EContactType {
  /** Застройщик. **/
  'Builder' = 'Builder',
  /** Представитель застройщика. **/
  'Seller' = 'Seller',
}
export enum ETariffType {
  /** Pro+. **/
  'ProPlus' = 'ProPlus',
  /** Premium. **/
  'Premium' = 'Premium',
}
export type TNewbuildingContactForPromoSnippetOnMapResponse_CompanyId = null | number;

export type TNewbuildingContactForPromoSnippetOnMapResponse_CompanyName = null | string;

export type TNewbuildingContactForPromoSnippetOnMapResponse_SiteBlockId = null | number;
